import apiUseCases from "@src/cloud-connect/api";
import { parseAxiosApiError } from "@src/cloud-connect/utils/parse-axios-api-error";
import store from "@src/reducers/store";

export interface ResendInvitationEmailResult {
  success: boolean;
  error?: string;
}

export const resendInvitationEmailUseCase = async (
  userId,
): Promise<ResendInvitationEmailResult> => {
  try {
    const namespace = store.getState().yourSlice.authContext.customerNamespace;

    await apiUseCases.postResendInvitationEmail(namespace, userId);

    return {
      success: true,
    };
  } catch (error) {
    return {
      success: false,
      error: parseAxiosApiError(
        error,
        "Failed to resend invitation email. Please try again later.",
      ).message,
    };
  }
};
